export const SMALL = 'SMALL'
export const MEDIUM = 'MEDIUM'
export const LARGE = 'LARGE'
export const XLARGE = 'XLARGE'
export const SMALL_SIZE = 210
export const MEDIUM_SIZE = 260
export const LARGE_SIZE = 318
export const XLARGE_SIZE = 435
export const GAP_MIN = 10
export const GAP_MAX = 30
export const MIN_WINDOW_WIDTH = 1366
export const PADDING = 40
export const MAX_MODULES_TO_DISPLAY = 3

export const MODULE_LAYOUT_SIZE = {
  [SMALL]: SMALL_SIZE,
  [MEDIUM]: MEDIUM_SIZE,
  [LARGE]: LARGE_SIZE,
  [XLARGE]: XLARGE_SIZE,
}
